import { FC } from "react"

const AppFooterTrademark: FC = () => {
    return (
        <span className="block text-xs text-gray-300 sm:text-center">
            Este site não se responsabiliza enquanto ao uso inadequado dos conteúdos baixados por aqui.
        </span>
    )
}

export default AppFooterTrademark